<template>
  <div v-loading="loading" class="outs">
    <titleStyle :more-url="moreUrl+'&name='+colList[colIndex].name" :text="colList[colIndex].name" />

    <div class="content1">
      <itemContent :data-list="dataList" />
    </div>
  </div>
</template>

<script>
import titleStyle from '../titleStyle.vue'
import itemContent from './TextAndImg.vue'
export default {
  components: {
    titleStyle,
    itemContent
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    moreUrl: {
      type: String,
      default: ''
    },
    param: {
      type: Object,
      default: () => {
        return { top: 6, type: 1 }
      }
    }
  },
  data() {
    return {
      dataList: [],
      loading: true
    }
  },
  computed: {
    colList() {
      return this.$store.state.app.colList
    },
    colIndex() {
      return this.param.type - 1
    }
  },

  mounted() {},
  created() {
    this.getInit()
  },

  methods: {
    getInit() {
      const newParam = JSON.parse(JSON.stringify(this.param))
      delete newParam.type
      this.$store.dispatch('home/HomeGetSzNews', { ...newParam, ...this.colList[this.colIndex] }).then((res) => {
        if (res.code === 0) {
          this.dataList = res.data
        } else {
          this.$message.error(res.msg || '请求失败,请刷新重试')
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .outs{
    padding: .25rem .16rem .20rem .16rem;
  }
</style>
